import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Shared';
const faqs = [{
  q: '¿Sirve si recién empiezo con Flores de Bach?',
  a: 'Especialmente si recién empezás. El Botiquín Bach te da la estructura táctica desde la primera sesión. No tenés que improvisar ni esperar años. El Tomo I es tu guía de protocolos y síntomas, el Tomo II son tus fórmulas listas para aplicar, y los bonus te enseñan a protegerte y a monetizar. Muchas terapeutas lo usan desde el día 1.'
}, {
  q: '¿Incluye un listado de las 38 Flores de Bach con sus palabras clave?',
  a: 'Sí. 🌸 Ahora tu Botiquín también incluye el Mapa Rápido de las 38 Flores de Bach™, una referencia visual con las 38 Flores organizadas en sus 7 grupos emocionales, sus palabras clave y diferenciales rápidos entre flores que pueden parecer similares. Podés utilizarlo desde el celular o tablet, o imprimirlo para tenerlo siempre a mano como material de consulta. No reemplaza tu criterio profesional: está diseñado para ayudarte a observar, diferenciar y explorar cada caso con mayor claridad.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Acceso inmediato en 5 minutos. Después de confirmar el pago en Mercado Pago recibís un email con el link de descarga. Son archivos PDF de alta calidad, descargables y listos para imprimir o usar en tablet. No requiere internet después de descargar.'
}, {
  q: '¿Necesito imprimirlo todo?',
  a: 'No. Muchas terapeutas lo tienen en tablet dentro del consultorio. Otras imprimen solo los tomos, otras solo los bonus. Es completamente flexible. Lo importante es que lo tengas a mano cuando lo necesites.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía sin preguntas. Si en 7 días te das cuenta de que no era para vos, escribinos y te reintegramos el dinero. Sin letra chica.'
}, {
  q: '¿Puedo compartirlo con otras terapeutas?',
  a: 'No. El Botiquín Bach es para uso personal único y está protegido por derechos de autor. Cada terapeuta necesita su propia licencia. Si querés regalárselo a una colega, podés enviarle el link de compra con descuento.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-54" data-mp="2az20jzbypqqn">
      <div className="mb-10 text-center" data-id="element-55" data-mp="2avwbgk3c2oux">
        <h2 className="flex justify-center font-display text-2xl font-bold text-brand-green md:text-4xl" data-id="element-56" data-mp="38lrbwzsk1fp6">
          <span className="mr-3" data-id="element-57" data-mp="33nfzqieset3s">❓</span>LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>
      <div className="space-y-4" data-id="element-58" data-mp="2ymjy6bhwrj1j">
        {faqs.map((faq, index) => <div key={faq.q} className="paper-panel overflow-hidden rounded-2xl border-l-4 border-l-brand-greenMid" data-id="element-59" data-mp="2ulq8pdothw6j" data-mpi={index}>
            <button type="button" aria-expanded={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-brand-parchment focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-amber" data-id="element-60" data-mp="1n8o7c5hn5luh">
              <span className="pr-8 text-sm font-semibold text-brand-green md:text-base" data-id="element-61" data-mp="7oysooifl1n1">{faq.q}</span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-goldDark transition-transform duration-200 ease-out ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-62" data-mp="cgyvcopvy8nb" />
            </button>
            <AnimatePresence initial={false} data-id="element-63" data-mp="mcjqc2wje8nk">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-64" data-mp="qgzx06dz5k3u">
                  <p className="border-t border-brand-green/10 bg-white px-6 py-4 text-sm leading-relaxed text-brand-textLight md:text-base" data-id="element-65" data-mp="2x77g1k2yssdo">
                    {faq.a}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}